import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const LegalNotice = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 pb-24" data-testid="legal-notice-page">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)} data-testid="back-btn">
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <h1 className="text-xl font-bold text-slate-900">Mentions légales</h1>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-8">
        <article className="prose prose-slate prose-sm max-w-none space-y-6">

          <h2 className="text-lg font-semibold text-slate-900 mt-4">1. Éditeur de l'application</h2>
          <ul className="list-none pl-0 space-y-1 text-sm text-slate-700">
            <li><strong>Application :</strong> AquaReport</li>
            <li><strong>Responsable de la publication :</strong> Frédéric GROSSET</li>
            <li><strong>Société :</strong> AVIS DOM PLUS Conseil</li>
            <li><strong>SIRET :</strong> 837 514 884 00027</li>
            <li><strong>Email :</strong>{" "}
              <a href="mailto:support@avidomplus.com" className="text-sky-600 hover:underline" data-testid="legal-contact-email">
                support@avidomplus.com
              </a>
            </li>
          </ul>

          <h2 className="text-lg font-semibold text-slate-900 mt-8">2. Nom de domaine</h2>
          <p className="text-sm text-slate-700">
            Le nom de domaine <strong>aquareport.re</strong> est enregistré et géré via <strong>Hostinger</strong>.
          </p>

          <h2 className="text-lg font-semibold text-slate-900 mt-8">3. Hébergement</h2>
          <p className="text-sm text-slate-700">
            L'application AquaReport est hébergée sur une infrastructure cloud sécurisée via la plateforme <strong>Emergent</strong>. Les données sont stockées sur des serveurs protégés avec des mesures de sécurité conformes aux standards de l'industrie.
          </p>

          <h2 className="text-lg font-semibold text-slate-900 mt-8">4. Responsabilité</h2>
          <p className="text-sm text-slate-700">
            L'utilisation de l'application AquaReport se fait sous la responsabilité de l'utilisateur. AVIS DOM PLUS Conseil met tout en oeuvre pour assurer la disponibilité et la fiabilité du service, mais ne saurait être tenue responsable des éventuels dommages directs ou indirects résultant de l'utilisation de l'application, y compris les interruptions de service, les pertes de données ou les erreurs techniques.
          </p>

          <h2 className="text-lg font-semibold text-slate-900 mt-8">5. Propriété intellectuelle</h2>
          <p className="text-sm text-slate-700">
            L'ensemble des éléments composant l'application AquaReport (code source, interface graphique, textes, logos, images) sont protégés par le droit de la propriété intellectuelle. Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable d'AVIS DOM PLUS Conseil est strictement interdite.
          </p>

          <h2 className="text-lg font-semibold text-slate-900 mt-8">6. Protection des données</h2>
          <p className="text-sm text-slate-700">
            Pour en savoir plus sur la collecte et le traitement de vos données personnelles, veuillez consulter notre{" "}
            <a href="/privacy" className="text-sky-600 hover:underline" data-testid="legal-privacy-link">
              Politique de confidentialité
            </a>.
          </p>
        </article>
      </main>
    </div>
  );
};

export default LegalNotice;
